import { render, staticRenderFns } from "./Home_essentials_desktop.vue?vue&type=template&id=01a9d875&"
import script from "./Home_essentials_desktop.vue?vue&type=script&lang=js&"
export * from "./Home_essentials_desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports